// packages/shared-hooks/src/auth/useChangePassword.ts
// Pure API mutation — consumer wires store-clear + navigate on success.
import { useMutation } from '@tanstack/react-query';
import {
  ChangePasswordResponseSchema,
  type ChangePasswordInput,
  type ChangePasswordResponse,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useChangePassword() {
  const client = useApiClient();
  return useMutation<ChangePasswordResponse, unknown, ChangePasswordInput>({
    mutationFn: (input) =>
      client.post<ChangePasswordResponse>(
        '/auth/change-password',
        input,
        {},
        ChangePasswordResponseSchema,
      ),
  });
}
